<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<main-content
			v-if="!page.introblock"
			:title="page.title || page.header"
			:subtitle="page.subtitle"
			:content="page.content"
			:intro-image="{
				image: page.introductionImage,
				imageWebp: page.introductionImageWebp,
			}"
		/>

		<intro-block v-if="page.introblock" :item="page.introblock" />

		<section class="main-content gallery-section">
			<filter-buttons :items="galleryCategories" :filter="filter" @change-filter="filter = $event" />
			<image-grid :items="galleryFiltered" :filter="filter" @change-filter="filter = $event" />
		</section>

		<contentblocks :items="page.contentblocks" />
		<frequently-asked-questions v-if="page.faqs && page.faqs.length" :items="page.faqs" />
	</page-container>
</template>

<script setup>
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const filter = ref('showAll');

const { data: galleryCategories } = await useWebsiteFetch('gallery', {
	query: { language: locale.value },
	key: `${locale.value}/gallery`,
});

const gallery = galleryCategories.value.map((item) => item.items).flat();

const galleryFiltered = computed(() => {
	if (filter.value === 'showAll') {
		return gallery;
	}

	return [...gallery].filter((item) => {
		if (!item.galleryCategorie) {
			return false;
		}

		return item.galleryCategorie.header === filter.value;
	});
});

onMounted(() => {
	Fancybox.bind('[data-fancybox]', {});
});
</script>

<style lang="scss" scoped>
.main-content.gallery-section {
	padding: 0;
}
</style>
